import { render, staticRenderFns } from "./SpecialCaseParcelStep.vue?vue&type=template&id=ab85cab4&scoped=true"
import script from "./SpecialCaseParcelStep.vue?vue&type=script&lang=js"
export * from "./SpecialCaseParcelStep.vue?vue&type=script&lang=js"
import style0 from "./SpecialCaseParcelStep.vue?vue&type=style&index=0&id=ab85cab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab85cab4",
  null
  
)

export default component.exports